import { useCollection } from '@platewell/query';
import { AddRecipeOptions } from '../components/add-recipe-options.js';
import { recipeNewRoute } from '../router.js';

export function RecipeNew() {
  const { collectionId } = recipeNewRoute.useSearch();
  // A collection that has since been deleted is ignored, and the recipes go to the
  // household's import collection as they would from a plain New Recipe link.
  const collection = useCollection(collectionId);
  const target = collection == null ? undefined : collectionId;

  return (
    <div className="editor" style={{ maxWidth: 560 }}>
      <h1>New recipe</h1>
      <AddRecipeOptions collectionId={target} />
    </div>
  );
}
